export default __webpack_public_path__ + "static/media/logoCaltex.8a28bbbd.jpeg";